<script setup lang="ts">
const { tabindex = 0 } = defineProps<{
  checked?: boolean
  disabled?: boolean
  invalid?: boolean
  tabindex?: number | `${number}`
  truncate?: boolean
}>()

defineEmits(['click'])
</script>
<template>
  <label
    class="focus:ring-secondary-200 group relative flex w-full items-start rounded-md px-2 py-2.5 ring-offset-2 outline-none focus:ring-2"
    :class="{
      'hover:bg-neutral-light text-neutral-900': !checked && !disabled,
      'cursor-pointer': !disabled,
      'cursor-default': disabled,
    }"
    :tabindex="tabindex"
    @click.prevent="!disabled && $emit('click')"
  >
    <span class="relative mr-3 flex size-4 items-center justify-center">
      <input
        class="pointer-events-none relative top-px size-4 appearance-none rounded border bg-neutral-50 checked:border-transparent focus:ring-1"
        :class="{
          'bg-secondary-600': checked && !disabled,
          'bg-neutral-600': checked && disabled,
          'border-error-500': invalid,
          'border-neutral-300': !invalid,
        }"
        :checked="checked"
        :disabled="disabled"
        tabindex="-1"
        type="checkbox"
      />
      <span
        role="presentation"
        class="i-fluent-checkmark-12-filled absolute top-0.5 size-3.5 text-white"
        :class="{
          'opacity-0': !checked,
        }"
      />
    </span>
    <span
      class="body-2 w-full max-w-prose text-left"
      :class="{
        'text-neutral-600': disabled,
        'truncate whitespace-nowrap': truncate,
        'text-error-dark': invalid,
        'text-neutral-900': !invalid && !disabled,
      }"
    >
      <slot />
    </span>
    <slot name="append" />
  </label>
</template>
